<template>
  <table id="carClass">
    <thead>
      <tr>
        <td style="width: 100px; padding-left: 10px">作业车辆</td>
        <td style="width: 100px">负责人</td>
        <td style="width: 130px">电话</td>
        <td>排班</td>
        <td>操作</td>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(x, index) in item.carClasses" :key="index">
        <td>
          <select-car :name="x.carNo" @update:name="x.carNo = $event">
          </select-car>
        </td>
        <td><Input v-model="x.manager" placeholder="请输入"></Input></td>
        <td><Input v-model="x.tel" placeholder="请输入"></Input></td>
        <td>
          <ul id="wewewe">
            <li v-for="(t, key) in x.classesList" :key="key">
              <Select v-model="t.startTime">
                <Option
                  v-for="(x, index) in $t('times')"
                  :value="x"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
              <span>至</span>
              <Select v-model="t.endTime">
                <Option
                  v-for="(x, index) in $t('times')"
                  :value="x"
                  :key="index"
                  >{{ x }}</Option
                >
              </Select>
              <Button
                @click="delClass(index, key)"
                :type="key == 0 ? 'success' : 'error'"
                ghost
                :icon="key == 0 ? 'md-add' : 'md-close'"
              ></Button>
            </li>
        
          </ul>
        </td>
        <td>
          <a @click="delCarClass(index)">{{ index == 0 ? "添加" : "删除" }}</a>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      item: {
        lineId: 1,
        carClasses: [
          {
            carNo: "",
            manager: "",
            tel: "",
            classesList: [{ startTime: "09:00", endTime: "18:00" }],
          },
        ],
      },
    };
  },
  methods: {
    watchClass() {
      var aaa = this.item.carClasses[0].carNo.length;
      var bbb = this.item.carClasses[0].classesList.length;
      if (aaa > 0 && bbb > 0) {
        return true;
      }else{
        return false;
      }
    },
    reData(id) {
      this.item.lineId = id;
      this.saveCarClass();
    },
    saveCarClass() {
      axios({
        method: "post",
        url: axios.mwm + "/schedule/add",
        data: this.item,
      }).then((res) => {
        if (res) {
          this.$emit("close");
        }
      });
    },
    getList(id) {
      //lineId
      axios({
        method: "post",
        url: axios.mwm + "/schedule/list",
        data: { lineId: id },
      }).then((res) => {
        if (res) {
          console.log(res);
          var data = res.data.data.dataList;
          this.item.carClasses = data;
          console.log(this.item);
        }
      });
    },
    delCarClass(index) {
      console.log(index);
      if (index == 0) {
        this.addCarClass();
      } else {
        this.item.carClasses.splice(index, 1);
      }
    },
    delClass(index, key) {
      if (key == 0) {
        this.addClass(index);
      } else {
        this.item.carClasses[index].classesList.splice(key, 1);
      }
    },
    addClass(index) {
      var obj = { startTime: "09:00", endTime: "10:00" };
      this.item.carClasses[index].classesList.push(obj);
    },
    addCarClass() {
      var obj = {
        carNo: "粤A1111111",
        manager: "张三",
        tel: "13453454323",
        classesList: [
          { startTime: "09:00", endTime: "10:00" },
          { startTime: "12:00", endTime: "14:00" },
        ],
      };
      this.item.carClasses.push(obj);
    },
  },
};
</script>
<style lang="">
#carClass {
  width: 100%;
  padding: 10px;
}
#carClass thead tr {
  background: #f1f1f1;
  height: 36px;
}
#carClass tbody tr {
  padding-bottom: 20px;
}
#carClass ul#wewewe {
  margin: 10px;
  position: relative;
}

#carClass ul#wewewe li {
  display: flex;
}
#carClass ul#wewewe li i {
  font-size: 18px;
  margin-left: 4px;
  margin-right: 4px;
}
#carClass ul#wewewe li span {
  line-height: 30px;
  margin: auto 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/carsys/paibanTool.vue